import React from "react";

const tsmclogo = require("../assets/images/TSMC_LOGO.jpg");

const MainHeader: React.FC = () => {
  return (
    <>
      <div className="app-heading">
          <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
            <img src={tsmclogo} alt="TSMC Logo" className="app-heading-logo" />
            <span className="app-heading-title">
              Continuing Professional Development - Telangana Medical Council
            </span>
          </div>
        </div>
    </>
  );
};

export default MainHeader;
